import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getBiContentViewStatus } from '../../DeviationPage/redux/selectors';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import {
  BiContextProvidedValue,
  BiData,
  ItemClickBiEvent,
  ViewTierUniqueBiEvent,
} from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../types/deviation';

export type ExtraBiDataForDeviationLink = Pick<
  ItemClickBiEvent,
  | 'sectionid'
  | 'sectionname'
  | 'section_typeid'
  | 'sectionrank'
  | 'sectiontype'
  | 'rank'
  | 'notification_sender_id'
>;
export type ExtraBiDataForTierLink = Pick<
  ViewTierUniqueBiEvent,
  | 'sectionid'
  | 'sectionname'
  | 'section_typeid'
  | 'sectionrank'
  | 'sectiontype'
  | 'rank'
>;

/** Returns correct click BI events for deviation links.
 * Please do not piggyback for other event types */
export function useBiDataForDeviationLink(
  deviation?: PapiDeviation,
  extraData?: ExtraBiDataForDeviationLink | ExtraBiDataForTierLink
) {
  const contentViewStatus = useSelector(
    state => deviation && getBiContentViewStatus(state, deviation)
  );
  const { needsSubscription, isSubscribedButBlocked } =
    useSubscriptionTier(deviation);

  if (!deviation) {
    return undefined;
  }

  const typeid = getDeviationResourceType(deviation);
  const itemid = deviation.deviationId;
  const creatorid = deviation.author?.useridUuid;

  if (typeid === DeviationResourceType.TIER) {
    return getBiDataForTierLink(deviation, extraData);
  }

  return BiData<ItemClickBiEvent>({
    component: BiContextProvidedValue,
    view: BiContextProvidedValue,
    sectionid: BiContextProvidedValue,
    sectionname: BiContextProvidedValue,
    section_typeid: BiContextProvidedValue,
    sectiontype: BiContextProvidedValue,
    sectionrank: BiContextProvidedValue,
    widgetname: BiContextProvidedValue,
    rank: BiContextProvidedValue,
    sort_type: BiContextProvidedValue,
    reason_shown: BiContextProvidedValue,
    page_typeid: BiContextProvidedValue,
    page_itemid: BiContextProvidedValue,
    ...extraData,
    evid: 100,
    typeid,
    itemid,
    creatorid,
    content_view_status:
      needsSubscription || isSubscribedButBlocked
        ? 'subscription_locked'
        : contentViewStatus,
  });
}

export function getBiDataForTierLink(
  deviation?: PapiDeviation,
  extraData?: ExtraBiDataForTierLink
) {
  if (!deviation) {
    return undefined;
  }

  const typeid = getDeviationResourceType(deviation);
  const itemid = deviation.deviationId;

  return BiData<ViewTierUniqueBiEvent>({
    sectionid: BiContextProvidedValue,
    sectionname: BiContextProvidedValue,
    section_typeid: BiContextProvidedValue,
    sectiontype: BiContextProvidedValue,
    sectionrank: BiContextProvidedValue,
    rank: BiContextProvidedValue,
    ...extraData,
    evid: 545,
    typeid,
    itemid,
  });
}
